"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppVersionDto = void 0;
const AppDto_1 = require("../apps/AppDto");
class AppVersionDto {
    constructor(params) {
        this.appType = "";
        this.dataVersion = "";
        this.baseBackgroundStyle = "";
        this.showChooseManufacturerScreen = false;
        this.createdAt = "";
        this.updatedAt = "";
        this.sourceVersion = "";
        this.multipleLocationStartupScreen = "";
        this.enableStartupSound = false;
        this.chooseLocationStyle = "";
        this.menuButtonText = "";
        this.contactButtonText = "";
        this.landingScreenNavbarStyle = "";
        this.inventoryPricingPosition = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.appId = params.appId;
        this.appType = params.appType;
        this.dataVersion = params.dataVersion;
        this.baseBackgroundStyle = params.baseBackgroundStyle;
        this.showChooseManufacturerScreen = params.showChooseManufacturerScreen;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        this.sourceVersion = params.sourceVersion;
        this.multipleLocationStartupScreen = params.multipleLocationStartupScreen;
        this.enableStartupSound = params.enableStartupSound;
        this.chooseLocationStyle = params.chooseLocationStyle;
        this.menuButtonText = params.menuButtonText;
        this.contactButtonText = params.contactButtonText;
        this.landingScreenNavbarStyle = params.landingScreenNavbarStyle;
        this.inventoryPricingPosition = params.inventoryPricingPosition;
        if (params.app !== undefined) {
            this.app = params.app ? new AppDto_1.AppDto(params.app) : null;
        }
    }
}
exports.AppVersionDto = AppVersionDto;
//# sourceMappingURL=AppVersionDto.js.map